let ldClientInstance = null;

export const setLDClient = (client) => {
  ldClientInstance = client;
};

export const getFlag = (flagKey) => {
  if (!ldClientInstance) {
    console.warn("LaunchDarkly client not initialized");
    return false;
  }

  return ldClientInstance.variation(flagKey);
};

export default {
  getFlag,
  setLDClient
};
